import { useEffect, useRef, Dispatch, SetStateAction } from 'react';
import { bizcalPolicy } from '../../utils/api/bizcal';

// A NEW quotation's expiry is pre-filled "today + N days" (Owner 2026-08-29). N is the issuing firm's
// policy (Admin → Companies → Billing & reminders, services/firmPolicy.ts). The form opens with its
// built-in pre-fill; once the company is known the firm's own N replaces it — but only while the date
// is still the one put there automatically, never over a date the operator typed.
export function useQuoteValidDefault(active: boolean, companyId: string, due: string, setDue: Dispatch<SetStateAction<string>>): void {
  const auto = useRef(due);
  useEffect(() => {
    if (!active || !companyId) return;
    let live = true;
    bizcalPolicy(companyId).then(p => {
      const n = Number(p.quotationValidDays);
      if (!live || !Number.isInteger(n) || n <= 0) return;
      const vd = new Date(); vd.setDate(vd.getDate() + n);   // same arithmetic as the form's own pre-fill
      const next = vd.toISOString().slice(0, 10);
      setDue(cur => { if (cur !== auto.current) return cur; auto.current = next; return next; });
    }).catch(() => { /* keep the built-in pre-fill */ });
    return () => { live = false; };
  }, [active, companyId]); // eslint-disable-line react-hooks/exhaustive-deps
}
